import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import OrderComplete from '@/components/order/Complete'
import OrderConfirm from '@/components/order/Confirm'
import OrderTransport from '@/components/order/Transport'
import OrderVehicle from '@/components/order/default/Vehicle'
import OrderMeihenVehicle from '@/components/order/meihen/Vehicle'
import OrderIndex from '@/components/order/Index'
import HistoryIndex from '@/components/history/Index'
import HistoryDetail from '@/components/history/Detail'
import TrialIndex from '@/components/trial/Index'
import SettingIndex from '@/components/setting/Index'
import SettingCreate from '@/components/setting/Create'
import SettingCompanyIndex from '@/components/setting/company/Index'
import InquiryIndex from '@/components/inquiry/Index'
import PasswordIndex from '@/components/password/Index'
import PasswordEdit from '@/components/password/Edit'
import SettingEdit from '@/components/setting/Edit'
import ApplyUsed from '@/components/apply/Used'
import ApplyLease from '@/components/apply/Lease'
import ApplyComplete from '@/components/apply/Complete'
import Store from '@/store/index.js'
import AdminIndex from '@/components/admin/Index'
import Constant from '@/const'
import Kiyaku from '@/components/Kiyaku'
import NotFound from '@/components/NotFound'
import Maintenance from '@/components/Maintenance'
import Reactivate from '@/components/Reactivate'
import EstimateIndex from '@/components/estimate/Index'
import EstimateDetail from '@/components/estimate/Detail'
import ProxyLogin from '@/components/ProxyLogin'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import jQuery from 'jquery'
const $ = jQuery

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Login', component: Login, meta: { isPublic: true } },
    {
      path: '/proxy',
      name: 'ProxyLogin',
      component: ProxyLogin,
      meta: { isAll: true },
    },
    {
      path: '/password',
      name: 'PasswordIndex',
      component: PasswordIndex,
      meta: { isPublic: true },
    },
    {
      path: '/password/edit',
      name: 'PasswordEdit',
      component: PasswordEdit,
      meta: { isPublic: true },
    },
    {
      path: '/activate',
      name: 'Activate',
      component: PasswordEdit,
      meta: { isPublic: true },
    },
    {
      path: '/apply/used',
      name: 'ApplyUsed',
      component: ApplyUsed,
      meta: { isPublic: true },
    },
    {
      path: '/apply/lease',
      name: 'ApplyLease',
      component: ApplyLease,
      meta: { isPublic: true },
    },
    {
      path: '/apply/complete',
      name: 'ApplyComplete',
      component: ApplyComplete,
      meta: { isPublic: true },
    },
    { path: '/home', name: 'Home', component: Home },
    { path: '/order', name: 'OrderIndex', component: OrderIndex },
    {
      path: '/order/transport',
      name: 'OrderTransport',
      component: OrderTransport,
    },
    { path: '/order/vehicle', name: 'OrderVehicle', component: OrderVehicle },
    { path: '/order/confirm', name: 'OrderConfirm', component: OrderConfirm },
    {
      path: '/order/complete',
      name: 'OrderComplete',
      component: OrderComplete,
    },
    {
      path: '/order/meihen/transport',
      name: 'OrderMeihenTransport',
      component: OrderTransport,
    },
    {
      path: '/order/meihen/vehicle',
      name: 'OrderMeihenVehicle',
      component: OrderMeihenVehicle,
    },
    {
      path: '/order/meihen/confirm',
      name: 'OrderMeihenConfirm',
      component: OrderConfirm,
    },
    {
      path: '/order/meihen/complete',
      name: 'OrderMeihenComplete',
      component: OrderComplete,
    },
    { path: '/history', name: 'HistoryIndex', component: HistoryIndex },
    {
      path: '/history/detail/:id',
      name: 'HistoryDetail',
      component: HistoryDetail,
    },
    { path: '/trial', name: 'TrialIndex', component: TrialIndex },
    { path: '/setting', name: 'SettingIndex', component: SettingIndex },
    {
      path: '/setting/create',
      name: 'SettingCreate',
      component: SettingCreate,
    },
    { path: '/setting/edit', name: 'SettingEdit', component: SettingEdit },
    {
      path: '/setting/company',
      name: 'SettingCompanyIndex',
      component: SettingCompanyIndex,
    },
    { path: '/inquiry', name: 'InquiryIndex', component: InquiryIndex },
    {
      path: '/admin',
      name: 'AdminIndex',
      component: AdminIndex,
      meta: { isAdmin: true },
    },
    {
      path: '/kiyaku',
      name: 'Kiyaku',
      component: Kiyaku,
      meta: { isAll: true },
    },
    {
      path: '/reactivate',
      name: 'Reactivate',
      component: Reactivate,
      meta: { isAll: true },
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: Maintenance,
      meta: { isAll: true },
    },
    { path: '/logout', name: 'Logout', component: Home },
    { path: '*', name: 'NotFound', component: NotFound, meta: { isAll: true } },
    { path: '/estimate', name: 'EstimateIndex', component: EstimateIndex },
    {
      path: '/estimate/detail/:id',
      name: 'EstimateDetail',
      component: EstimateDetail,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 } // トップに移動
  },
})

// 認証トークンによるアクセス制限
router.beforeEach((to, from, next) => {
  Store.commit('screen/create', { isInvisibleFilter: true, isLogoOnly: false })
  // ログイン前後の両方で参照可能な画面
  if (to.matched.some((page) => page.meta.isAll)) {
    // サイト利用規約はログイン後も遷移可能
    clearFilterAndLocks()
    next()
    // ログイン状態で公開画面にアクセスした場合
  } else if (
    to.matched.some((page) => page.meta.isPublic) &&
    Store.state.auth.LOGINED
  ) {
    if (Store.state.user.data.ROLE === Constant.USER.ROLE.ADMIN) {
      clearFilterAndLocks()
      next({ name: 'AdminIndex' })
    } else {
      clearFilterAndLocks()
      next({ name: 'Home' })
    }
    // 通常画面遷移
  } else if (
    to.matched.some((page) => page.meta.isPublic) ||
    Store.state.auth.ACCESS_TOKEN
  ) {
    // ログイン後の画面の遷移
    if (Store.state.auth.ACCESS_TOKEN) {
      const isAdmin = Store.state.user.data.ROLE === Constant.USER.ROLE.ADMIN

      // トークン認証＆有効期限の更新
      Store.dispatch('auth/update')
        .then((res) => {
          Store.dispatch('auth/create', { logined: true })

          // 管理用画面に一般ユーザがアクセスした場合
          if (to.matched.some((page) => page.meta.isAdmin) && !isAdmin) {
            clearFilterAndLocks()
            return next({ name: 'Home' })
          }
          // 一般ユーザ画面に管理者ユーザがアクセスした場合
          if (to.matched.some((page) => !page.meta.isAdmin) && isAdmin) {
            clearFilterAndLocks()
            return next({ name: 'AdminIndex' })
          }
          // 指定したURL
          clearFilterAndLocks()
          next()
        })
        .catch(() => {
          Store.dispatch('auth/destroy')
          Store.commit('screen/create', { isSpiner: false })
          clearFilterAndLocks()
          return next({ name: 'Login' })
        })
      // 公開画面に遷移
    } else {
      Store.commit('screen/create', { isSpiner: false })
      clearFilterAndLocks()
      next()
    }
    // 未ログイン状態でログイン後画面にアクセスした場合
  } else if (to.matched.some((page) => !page.meta.isPublic)) {
    clearFilterAndLocks()
    next({ name: 'Login' })
  }
})

// フィルタ、スピナー非表示、画面ロック解除
function clearFilterAndLocks() {
  clearAllBodyScrollLocks()
  $('body').css('overflow', '')
  $('body').css('position', '')
  Store.commit('screen/create', { isSpiner: false })
  Store.commit('screen/create', { isInvisibleFilter: false })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js